import React from 'react'
import { Route, Outlet } from 'react-router-dom'

import RouteGuard from 'components/AuthenticatedLayout/RouteGuard/RouteGuard'
import AdminSites from './AdminSites'
import Card from './Card'

const Layout = () => {
  return (
    <RouteGuard requiredRoles={['admin_sites']}>
      <Outlet />
    </RouteGuard>
  )
}

const AdminSitesRoutes = () => [
  <Route path="admin-sites" key="admin-sites" element={<Layout />}>
    <Route path="" element={<AdminSites />}>
      <Route path=":focusId" element={<Card />} />
    </Route>
  </Route>
]

export default AdminSitesRoutes
